import React from "react";
import { Link } from "react-router-dom";
import AlbetheineEye from "@/components/AlbetheineEye";
import CelticOrnament from "@/components/CelticOrnament";

export default function Footer() {
  return (
    <footer
      className="relative bg-charcoal-2 border-t border-[rgba(201,169,97,0.18)] pt-20 pb-10 overflow-hidden"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
        <div className="flex flex-col items-center mb-14">
          <AlbetheineEye size={64} className="opacity-80" />
          <div className="brand-name text-cream text-3xl mt-4">
            Tapped In Clarity
          </div>
          <div className="font-cinzel text-[0.7rem] text-gold tracking-[0.4em] mt-2">
            ALBETHEINE&apos;S ORACLE
          </div>
          <CelticOrnament size={80} className="mt-6 opacity-60" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8 mb-14">
          <div>
            <div className="font-cinzel text-gold text-[0.72rem] tracking-[0.32em] mb-4">
              SANCTUARY
            </div>
            <ul className="space-y-2 text-cream-soft text-[0.95rem]">
              <li>
                <a href="/#about" className="app-link">
                  About
                </a>
              </li>
              <li>
                <a href="/#offerings" className="app-link">
                  Offerings
                </a>
              </li>
              <li>
                <a href="/#pricing" className="app-link">
                  Pricing
                </a>
              </li>
              <li>
                <Link to="/contact" className="app-link">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="font-cinzel text-gold text-[0.72rem] tracking-[0.32em] mb-4">
              POLICIES
            </div>
            <ul className="space-y-2 text-cream-soft text-[0.95rem]">
              <li>
                <Link to="/terms" className="app-link" data-testid="footer-terms">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="app-link"
                  data-testid="footer-privacy"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/refund"
                  className="app-link"
                  data-testid="footer-refund"
                >
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/cancellation"
                  className="app-link"
                  data-testid="footer-cancellation"
                >
                  Cancellation Policy
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="font-cinzel text-gold text-[0.72rem] tracking-[0.32em] mb-4">
              ORDERS & DISPUTES
            </div>
            <ul className="space-y-2 text-cream-soft text-[0.95rem]">
              <li>
                <Link
                  to="/shipping"
                  className="app-link"
                  data-testid="footer-shipping"
                >
                  Shipping & Delivery
                </Link>
              </li>
              <li>
                <Link
                  to="/dispute"
                  className="app-link"
                  data-testid="footer-dispute"
                >
                  Dispute & Chargeback
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="font-cinzel text-gold text-[0.72rem] tracking-[0.32em] mb-4">
              SPEAK WITH US
            </div>
            <p className="text-cream-soft text-[0.95rem] leading-relaxed">
              Tapped In Clarity
              <br />
              Sole Trader · United Kingdom
              <br />
              Business address available on request.
            </p>
            <a
              href="mailto:tappedinclarity@gmail.com"
              className="block mt-3 app-link"
              data-testid="footer-email"
            >
              tappedinclarity@gmail.com
            </a>
          </div>
        </div>

        <div className="gold-divider mb-6" />
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-cream-muted text-xs font-cinzel tracking-[0.2em]">
          <div>© {new Date().getFullYear()} TAPPED IN CLARITY · ALL RIGHTS RESERVED</div>
          <div className="opacity-70">CRAFTED WITH REVERENCE · UK</div>
        </div>
      </div>
    </footer>
  );
}
